import { render, staticRenderFns } from "./KodomoSyokudo.vue?vue&type=template&id=2c05a3a2&scoped=true"
import script from "./KodomoSyokudo.vue?vue&type=script&lang=js"
export * from "./KodomoSyokudo.vue?vue&type=script&lang=js"
import style0 from "./KodomoSyokudo.vue?vue&type=style&index=0&id=2c05a3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05a3a2",
  null
  
)

export default component.exports